// extracted by mini-css-extract-plugin
export default {"root":"MakeOfferButton_root__V4nYn buttonPrimary"};